<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

    {{ value }}

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

	computed: {

		value: function() {

			if (!this.item.game.language.count) return 'n/a'

			if (this.item.game.language.rating === 1) return 'Complete'
			if (this.item.game.language.rating === 2) return 'High'
			if (this.item.game.language.rating === 3) return 'Medium'
			if (this.item.game.language.rating === 4) return 'Low'
			if (this.item.game.language.rating === 5) return 'None'

			return false

		}

	}

}

</script>

<style scoped>

</style>